import React, { Fragment, useEffect, useState } from "react";
import { APP_DOMAIN } from "../../constants/constants";


const ErrorBox = (props) => {
   //use isOpen state in case of onClick is not define
    const [isOpen, setIsOpen] = useState(props.openit);
    const handleToggle = () => {
        setIsOpen(!isOpen);
    };
    return <div className="d-flex-column error-box" >
        <div className="e-head">
            <div className="e-exclamation">
                <div className={`e-circle ${props?.success ? 'bg-success' : 'bg-error'}`}></div>
            </div>
            <h3>{props.message}</h3>
            {props?.hide_ignore_button ||  <div className="btn-ignore" onClick={() => props?.ignoreSuggestion && props.ignoreSuggestion()}>
                <img src={`${APP_DOMAIN}/assets/images/x-mark.svg`} />
                <span>Ignore</span>
            </div>}
            {props.disableDescription !== true && <span className="toggleIcon" onClick={props.onClick ?? handleToggle}>
                {(props.onClick ? props.openit : isOpen) ? <i className="icon-arrow-up-light"></i> : <i className="icon-arrow-down-light"></i>}
            </span>}
        </div>
        {isOpen && (
            <span className='e-body'>{props.description}</span>
        )}
    </div>
}
export default ErrorBox;